import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import Button from "react-bootstrap-button-loader";
import { Modal } from "react-bootstrap";
import { openSessionModal } from "TicketAction";
import { fetchAdditionalSessions } from "ContentActions";
import { DISPLAY_LOCAL_DATE_FORMAT } from "Constants";
import LocaleStrings from "Languages";
var Loader = require("react-loaders").Loader;

class AssociatedSessions extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = { sessionsData: "" };
  }

  componentDidMount() {
    if (this.props.ticketSesionModal && this.props.ticketSesionModal.data) {
      this.props.fetchAdditionalSessions(this.props.session, (res) => {
        this.setState({ sessionsData: res.data });
      });
    }
  }

  closeModal() {
    this.props.openSessionModal({ showModal: false });
  }

  renderSessions() {
    return this.state.sessionsData.map((item, index) => {
      return (
        <div className="vertical-align-center session-item">
          <div className="custom-text1-primary-bold">
            {`- ${item.title}`} &nbsp;
          </div>
          <div className="custom-text1-primary-normal">
            {moment(item.starttime).format(
              `${DISPLAY_LOCAL_DATE_FORMAT} HH:mm`
            )}{" "}
            -{" "}
            {moment(item.endtime).format(`${DISPLAY_LOCAL_DATE_FORMAT} HH:mm`)}
          </div>
        </div>
      );
    });
  }

  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  render() {
    var { ticketSesionModal } = this.props;
    var { sessionsData } = this.state;

    return (
      <Modal
        className="modal-container"
        show={ticketSesionModal.showModal === true ? true : false}
        animation={true}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <Modal.Header>
          <div className="import-modal-title">
            {LocaleStrings.tickets_ticket_modal_title_view_associated_session}
          </div>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={() => this.closeModal()}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div style={{ minHeight: 100 }}>
            {Array.isArray(sessionsData) ? (
              <div className="assoicated-sessions-data">
                {sessionsData.length > 0 ? (
                  this.renderSessions()
                ) : (
                  <div className="custom-text1-primary-bold text-center">{`${LocaleStrings.tickets_ticket_modal_text_no_associated_session}`}</div>
                )}
              </div>
            ) : (
              <div className="custom-align-center">{this.renderLoader()}</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-custom-white" onClick={this.closeModal}>
            {LocaleStrings.button_close}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  fetchAdditionalSessions,
  openSessionModal,
})(AssociatedSessions);
